export function createGatewayStatusCache(fetchGateway) {
  const entries = new Map();
  const pendingStatuses = new Map();
  return {
    clear() { entries.clear(); pendingStatuses.clear(); },
    get(gatewayId) {
      if (!gatewayId) return Promise.resolve(undefined);
      const key = String(gatewayId);
      if (entries.has(key)) return entries.get(key).promise;
      const entry = {};
      entry.promise = Promise.resolve().then(() => fetchGateway(gatewayId)).then(user => {
        const online = pendingStatuses.has(String(user.id)) ? pendingStatuses.get(String(user.id)) : user.online;
        const normalized = typeof online === "boolean" ? online :
          ["true", "1", "online"].includes(String(online).toLowerCase()) ? true :
          ["false", "0", "offline"].includes(String(online).toLowerCase()) ? false : undefined;
        entry.userId = user.id;
        entry.status = normalized;
        entry.promise = Promise.resolve(normalized);
        return normalized;
      }).catch(() => {
        if (entries.get(key) === entry) entries.delete(key);
        return undefined;
      });
      entries.set(key, entry);
      return entry.promise;
    },
    updateUser(user) {
      if (user?.id == null || typeof user.status !== "boolean") return false;
      if (pendingStatuses.get(String(user.id)) === user.status) return false;
      pendingStatuses.set(String(user.id), user.status);
      if (pendingStatuses.size > 1000) pendingStatuses.delete(pendingStatuses.keys().next().value);
      for (const entry of entries.values()) {
        if (String(entry.userId) === String(user.id)) {
          entry.status = user.status;
          entry.promise = Promise.resolve(user.status);
        }
      }
      return true;
    },
  };
}
